"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var compat_1 = require("preact/compat");
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("./styles");
var TooltipArrow_1 = __importDefault(require("./icons/TooltipArrow"));
var Hint = (0, compat_1.memo)(function (props) {
    var children = props.children, arrowPosition = props.arrowPosition;
    var hintWrapperClass = (function () {
        switch (arrowPosition) {
            case 'top':
                return (0, clsx_1.default)(styles_1.classes.hintWrapper, styles_1.classes.hintWrapperTop);
            case 'bottom':
            default:
                return (0, clsx_1.default)(styles_1.classes.hintWrapper, styles_1.classes.hintWrapperBottom);
        }
    })();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: hintWrapperClass }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles_1.classes.dialogWrapper }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: styles_1.classes.dialogText }, { children: children })), (0, jsx_runtime_1.jsx)("div", __assign({ className: arrowPosition === 'top' ? styles_1.classes.arrowTopWrapper : styles_1.classes.arrowBottomWrapper }, { children: (0, jsx_runtime_1.jsx)(TooltipArrow_1.default, {}) }))] })) })));
});
exports.default = Hint;
